const CashBuyingSection = () => {
  return (
    <section className="py-20 bg-white">
      <div className="max-w-7xl mx-auto px-6">
        <div className="grid md:grid-cols-2 gap-12 items-center mb-16">
          <div>
            <img
              src="https://public.readdy.ai/ai/img_res/00e4794c4ed5d39757159b4dbfe7992e.jpg"
              alt="Cash home buying"
              className="w-full h-full rounded-xl shadow-xl object-cover"
            />
          </div>
          <div>
            <h2 className="text-4xl md:text-5xl font-bold mb-6 text-gray-900">
              The Power of <strong>Cash Offers</strong>
            </h2>
            <p className="text-lg text-gray-700 mb-6 leading-relaxed">
              When we say we're cash buyers, we mean it. We don't rely on bank financing, which means no appraisal contingencies, no loan approval delays, and no last-minute financing fall-throughs. Our cash offers provide certainty and speed that traditional buyers simply cannot match.
            </p>
            <p className="text-lg text-gray-700 mb-6 leading-relaxed">
              In the <strong>El Paso real estate market</strong>, cash is king. Sellers who accept our cash offers avoid the uncertainty of waiting for buyer financing approval, which can take 30-45 days or longer. They also avoid the risk of deals falling apart at the last minute due to financing issues—a common problem in traditional sales.
            </p>
            <p className="text-lg text-gray-700 leading-relaxed">
              Our cash buying power also means we can purchase properties that traditional buyers cannot. Homes that won't qualify for conventional financing due to condition issues, code violations, or other problems are perfect for us. We have the resources to handle any property, regardless of its current state.
            </p>
          </div>
        </div>

        <div className="bg-gradient-to-br from-teal-50 to-white rounded-xl shadow-lg p-8 md:p-12">
          <h3 className="text-3xl font-bold mb-8 text-gray-900 text-center">
            Cash vs. Traditional Sale: The Difference
          </h3>
          <div className="overflow-x-auto">
            <table className="w-full">
              <thead>
                <tr className="border-b-2 border-gray-300">
                  <th className="text-left py-4 px-4 text-gray-900 font-bold">Factor</th>
                  <th className="text-left py-4 px-4 text-teal-600 font-bold">Cash Sale (Us)</th>
                  <th className="text-left py-4 px-4 text-gray-600 font-bold">Traditional Sale</th>
                </tr>
              </thead>
              <tbody className="divide-y divide-gray-200">
                <tr>
                  <td className="py-4 px-4 font-semibold text-gray-900">Timeline</td>
                  <td className="py-4 px-4 text-gray-700">7-14 days</td>
                  <td className="py-4 px-4 text-gray-700">60-90 days</td>
                </tr>
                <tr>
                  <td className="py-4 px-4 font-semibold text-gray-900">Repairs Needed</td>
                  <td className="py-4 px-4 text-gray-700">None—we buy as-is</td>
                  <td className="py-4 px-4 text-gray-700">Usually required</td>
                </tr>
                <tr>
                  <td className="py-4 px-4 font-semibold text-gray-900">Commissions</td>
                  <td className="py-4 px-4 text-gray-700">$0</td>
                  <td className="py-4 px-4 text-gray-700">5-6% of sale price</td>
                </tr>
                <tr>
                  <td className="py-4 px-4 font-semibold text-gray-900">Closing Costs</td>
                  <td className="py-4 px-4 text-gray-700">We cover them</td>
                  <td className="py-4 px-4 text-gray-700">Seller pays 2-4%</td>
                </tr>
                <tr>
                  <td className="py-4 px-4 font-semibold text-gray-900">Showings</td>
                  <td className="py-4 px-4 text-gray-700">One visit only</td>
                  <td className="py-4 px-4 text-gray-700">Multiple showings</td>
                </tr>
                <tr>
                  <td className="py-4 px-4 font-semibold text-gray-900">Contingencies</td>
                  <td className="py-4 px-4 text-gray-700">None</td>
                  <td className="py-4 px-4 text-gray-700">Inspection, financing, appraisal</td>
                </tr>
                <tr>
                  <td className="py-4 px-4 font-semibold text-gray-900">Deal Certainty</td>
                  <td className="py-4 px-4 text-gray-700">Guaranteed closing</td>
                  <td className="py-4 px-4 text-gray-700">30-40% fall through</td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </section>
  );
};

export default CashBuyingSection;
